import { render, staticRenderFns } from "./MandatsUpdate.vue?vue&type=template&id=2075f9e2&"
import script from "./MandatsUpdate.vue?vue&type=script&lang=js&"
export * from "./MandatsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports